// App.js
import React, { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Lottie from 'react-lottie';
import loadingAnimation from './assets/anim/loading.json'; // Adjust path to loading.js

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // Check local storage for login status
    return localStorage.getItem('isLoggedIn') === 'true';
  });
  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    // Set a timer to stop loading after 2 seconds
    const timer = setTimeout(() => setIsLoading(false), 2000);

    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, []);

  useEffect(() => {
    // Sync login state with local storage
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

  // Lottie animation options
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation, // Your Lottie animation JSON
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Router>
      <div className="App">
        {isLoading ? (
          <div className="flex items-center justify-center min-h-screen">
            <Lottie options={defaultOptions} height={200} width={200} />
          </div>
        ) : (
          <Routes>
            <Route 
              path="/" 
              element={
                isLoggedIn ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <LoginPage onLogin={handleLogin} />
                )
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                isLoggedIn ? (
                  <Dashboard onLogout={handleLogout} />
                ) : (
                  <Navigate to="/" replace />
                )
              } 
            />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
